import { useEffect, useState } from "react";

/** Retrasa un valor para no disparar una consulta por cada tecla. */
export function useDebounce<T>(valor: T, milisegundos = 300): T {
  const [retrasado, setRetrasado] = useState(valor);

  useEffect(() => {
    const id = setTimeout(() => setRetrasado(valor), milisegundos);
    return () => clearTimeout(id);
  }, [valor, milisegundos]);

  return retrasado;
}
